/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import {
  GeneralModal,
  CustomTextField,
  ModalButton,
  MultiSelect,
} from '../index';
import { Typography, Grid } from '@mui/material';
// import { useState, useEffect} from "react";

export const AddDeptModal = (props) => {
  return (
    <GeneralModal
      open={props.open}
      onClose={props.onClose}
      style={{ width: '65%', p: 0, overflow: 'hidden' }}
    >
      <Grid container>
        <Grid
          item
          xs={6}
          sx={{
            bgcolor: '#1A202C',
            p: 4,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Typography
            sx={{
              lineHeight: '1',
              fontWeight: 500,
              fontSize: '20px',
            }}
            margin={0}
            variant="subtitle1"
            align="center"
          >
            Add Details
          </Typography>
          <CustomTextField
            onChange={props.deptNameOnChange}
            required={true}
            label="Department Name"
          />
          <CustomTextField
            onChange={props.deptDescOnChange}
            required={true}
            multiline={true}
            label="Department Description"
          />
          <CustomTextField
            onChange={props.deptMandaWorkDescOnChange}
            required={true}
            multiline={true}
            label="Mandatory Work Description"
          />
          <CustomTextField
            onChange={props.deptLocationOnChange}
            required={true}
            label="Location"
          />
        </Grid>
        <Grid item xs={6} sx={{ p: 4 }}>
          <Grid container direction="column" sx={{ height: '100%' }}>
            <Grid item>
              <Typography
                sx={{
                  lineHeight: '1',
                  fontWeight: 500,
                  fontSize: '20px',
                }}
                margin={0}
                variant="subtitle1"
                align="center"
              >
                Add Members
              </Typography>
              <CustomTextField
                // required={true}
                label="Manager"
              />
              <MultiSelect
                value={props.employeeName}
                onChange={props.handleSelectMembersChange}
                label="Members"
                items={props.names}
                itemName={props.employeeName}
                required={true}
              />
            </Grid>
            {/* <Grid item>
              <Typography
                sx={{
                  lineHeight: "1",
                  fontWeight: 500,
                  fontSize: "20px",
                  mt: 3,
                }}
                margin={0}
                variant="subtitle1"
                align="center"
              >
                Add Projects
              </Typography>
              <MultiSelect
                value={props.projectName}
                onChange={props.handleSelectProjectsChange}
                label="Projects"
                items={props.projects}
                itemName={props.projectName}
                // required={true}
              />
            </Grid> */}
            <Grid item>
              <Typography
                sx={{
                  lineHeight: '1',
                  fontWeight: 500,
                  fontSize: '20px',
                  mt: 3,
                }}
                margin={0}
                variant="subtitle1"
                align="center"
              >
                Add Message
              </Typography>
              <CustomTextField
                onChange={props.deptMessagingOnChange}
                required
                multiline={true}
                label="Message"
              />
            </Grid>
            <Grid item sx={{ mt: 2 }}>
              <ModalButton
                primaryBtnName="Save"
                secondaryBtnName="Cancel"
                primaryClickHandler={props.primaryClickHandler}
                secondaryClickHandler={props.secondaryClickHandler}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </GeneralModal>
  );
};
